import { Box, Skeleton, Stack, Typography } from '@mui/material';
import useLocalization from '../../../hooks/useLocalization';
import { zeroXDepositStyles as styles } from '../../../styles/components/zeroXDeposit';

type ZeroXDepositSkeletonProps = {
  currency: string;
};

const ZeroXDepositSkeleton = ({ currency }: ZeroXDepositSkeletonProps) => {
  const { t } = useLocalization();

  return (
    <Stack
      role='status'
      aria-busy
      aria-label={t('zeroXLoading')}
      sx={styles.readyCard}
      data-testid='zero-x-deposit-skeleton'
    >
      <Typography component='div' sx={styles.assetBadge}>
        {currency || <Skeleton variant='rounded' sx={styles.assetSkeleton} />}
      </Typography>

      <Box sx={styles.qrContainer}>
        <Skeleton variant='rounded' sx={styles.qr} />
      </Box>

      <Stack sx={styles.field}>
        <Typography sx={styles.label}>{t('cryptoAddress')}</Typography>

        <Box sx={styles.valueField}>
          <Skeleton variant='rounded' sx={styles.addressSkeleton} />
          <Skeleton variant='circular' sx={styles.copySkeleton} />
        </Box>
      </Stack>
    </Stack>
  );
};

export default ZeroXDepositSkeleton;
